'use strict';

var illustration = {};

exports.__exports = illustration;
//# sourceMappingURL=illustration2.cjs.map
